import type { SkillOption } from '../spark-activities/SkillsCombobox';
import type { ExpertTipSkill } from '../../types/expert-tip';

/** Maps API skills to combobox options with the primary domain's skills first; other order kept. */
export function toSkillOptions(skills: ExpertTipSkill[], primaryDomainId: number | null): SkillOption[] {
  const primary = skills.filter((s) => s.domainId === primaryDomainId);
  const rest = skills.filter((s) => s.domainId !== primaryDomainId);
  return [...primary, ...rest].map((s) => ({ id: s.id, title: s.title, domain: { title: s.domainTitle } }));
}
